import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import defaultAvatar from '@/assets/img/avatar.png';
import { useBasicStore } from '@/stores/basic';
import { UserInfo } from '@/stores/room';
import { storeToRefs } from 'pinia';
import { ICON_NAME } from '@/constants/icon';
import { ETUIRoomRole } from '../../../tui-room-core';
import SvgIcon from '../../common/SvgIcon.vue';

interface Props {
  userInfo: UserInfo,
  showMemberControl: Boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'memberInfo',
  props: {
    userInfo: null,
    showMemberControl: null
  },
  setup(__props: any) {

const props = __props as {
  userInfo: UserInfo,
  showMemberControl: Boolean,
}



const basicStore = useBasicStore();
const { isMaster } = storeToRefs(basicStore);

const isMe = computed(() => basicStore.userId === props.userInfo.userId);


return { __sfc: true,props, basicStore, isMaster, isMe, defaultAvatar, ICON_NAME, ETUIRoomRole, SvgIcon }
}

})